<template>
    <ac-modal :title="modalTitle" ref="modalRef" :size-class="'modal-lg'" data-keyboard="false" data-backdrop="static">
        <template v-if="widgetReady">
            <div class="row">
                <div class="col-lg-3 col-sm-6">
                    <p><span style="min-width: 12px;">Total Amount Due: </span></p>
                    <p><span style="min-width: 12px;">Payment for: </span></p>
                    <p style="font-weight: bold!important;">Reason: </p>
                </div>
                <div class="col-lg-3 col-sm-6">
                    <p>{{ netDebt | currency }}</p>
                    <p>{{ month }} / {{ year }}</p>
                    <p style="font-weight: bold!important;">{{ error }}</p>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="alert alert-warning">
                        <input type="checkbox" class="filled-in" id='debt-ver-check' v-model="memberAgrees">
                        <label for="debt-ver-check" style="text-align: left">
                            I agree, acknowledge and attest that I have been explicitly and directly been provided 
                            authorization and consent to execute this payment via credit/debit card on  {{ new Date() | shortDate }}
                        </label>
                    </div>
                    <p>
                        To update the group's payment method click
                        <a style="cursor: pointer; color: blue;" @click.prevent="sendToPaymentMethod">here</a>.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-xs-12">
                    <div class="modal-footer">
                        <div class="button-box">
                            <div>
                                <ac-button class="btn btn-sm btn-red" :action="closeModal">CANCEL</ac-button>
                                <ac-button class="btn btn-sm btn-green" :action="collectPayment">PAY</ac-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </ac-modal>
</template>

<script>
import { common } from "@/global/common";
import { api } from "@/global/framework/api"
import { notifications } from "@/global/notifications.js";
import AcButton from "../../../global/customHtmlElements/AcButton.vue";

export default {
    name: "CollectPaymentModal",
    components: { AcButton },
    data() {
        return {
            widgetReady: false,
            companyId: null,
            batchId: null,
            netDebt: 0,
            memberAgrees: false,
            month: '',
            error: '',
            paymentVm: {},
            debtType: ''
        };
    },
    computed: {
        modalTitle() {
            return `Outstanding ${this.debtType} Payment`;
        },
    },
    methods: {
        async showModal({companyId, batchId}) {   
            this.companyId = companyId;
            this.batchId = batchId;

            let debtInfo = await api.getDataWithTwoIds('Company', this.companyId, 'GetCompanyDebt', this.batchId);

            this.netDebt = debtInfo.amount;
            this.month = debtInfo.batchMonth;
            this.year = debtInfo.batchYear
            this.error = debtInfo.errorMessage;
            this.isCredit = debtInfo.isCredit;
            this.debtType = debtInfo.debtType;
            this.paymentVm = {
                batchId: this.batchId,
                amount: this.netDebt,
                month: this.month,
                year: this.year,
                isCredit: this.isCredit,
                deferPayment: debtInfo.deferPayment }
            this.widgetReady = true;
            this.$refs.modalRef.open();
        },
        closeModal() {
            this.$refs.modalRef.close();
        },
        async sendToPaymentMethod() {
            this.closeModal();
            this.$router.push({
                name: 'paymentMethod', params: { companyId: this.companyId }
            });
        },
        async collectPayment() {
            if (this.memberAgrees) {
                let result = await api.postWithId('Company', this.companyId, 'PayCompanyDebt', this.paymentVm);
                if (result) {                    
                    this.closeModal();
                    this.$emit("modal-closed");
                }
            }
            else {
                notifications.show({ title: "Failure!", message: "Must confirm member agrees to payment. Must have card on file." }, common.ACRESSA_NOTIFICATIONS.ERROR);
            }
        },
    },
}
</script>

<style scoped>
.modal-footer {
    padding-left: 0;
    padding-right: 0;
}
</style>